import Vue from 'vue'
import App from './App.vue'
import router from './router/index.js'
import store from '@/store'
// ElementUI 引入
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import animated from 'animate.css' // npm install animate.css --save安装，再引入
// 全局加载过滤器
import * as filters from './filters'
Vue.use(ElementUI)
Vue.use(animated)
// 阻止启动生产消息
Vue.config.productionTip = false
// filters 中的函数加载到全局过滤器
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

// 设置全局变量  可以通过 this.ossUrl调用
// Vue.prototype.ossUrl =
// pc端网站登录时 跳转到移动端网站
function urlredirect () {
  var sUserAgent = navigator.userAgent.toLowerCase()
  if (
    sUserAgent.match(
      /(ipod|iphone os|midp|ucweb|android|windows ce|windows mobile)/i
    )
  ) {
    // PC跳转移动端
    // window.location.href =
  } else {
    // 移动端 跳转到pc端
    // window.location.href =
  }
}
if (process.env.NODE_ENV !== 'development') {
  urlredirect()
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
